/**
 * Filter normalizer:
 * Converts API filters into our internal format.
 * @see {@link https://docs.joinmastodon.org/entities/filter/}
 */import{List as ImmutableList,Map as ImmutableMap,Record as ImmutableRecord,fromJS}from'immutable';// https://docs.joinmastodon.org/entities/filter/
export var FilterRecord=ImmutableRecord({id:'',phrase:'',context:ImmutableList(),whole_word:false,expires_at:'',irreversible:false});export var normalizeFilter=function normalizeFilter(filter){return FilterRecord(ImmutableMap(fromJS(filter)));};